export default "__VITE_ASSET__Dd$H5DGz__"